import { defineComponent as _defineComponent } from 'vue'
import { withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/star-icon.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-191c5eb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tile-header" }
const _hoisted_2 = ["innerHTML", "data-test"]
const _hoisted_3 = { class: "pathway-tile-grid" }
const _hoisted_4 = { class: "description grid-item" }
const _hoisted_5 = ["data-test"]
const _hoisted_6 = { class: "pathway-img-container grid-item" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = {
  key: 0,
  class: "benefits-container"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Benefits", -1))
const _hoisted_10 = ["data-test"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "bullet-point",
  class: "star-icon"
}, null, -1))

import { ref, onMounted } from "vue";
import cms from "../../services/cms/cms";
import { PathwayTileData } from "./select-team-pathway.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'pathway-tile',
  props: {
    pathway: {},
    isExpandedView: { type: Boolean }
  },
  emits: ["toggle-expanded-view"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const benefits = ref<any[] | undefined>([]);

const getBenefitList = (): void => {
  if (props.pathway) {
    benefits.value = props.pathway.data.benefits?.map((benefit) => {
      return benefit.benefit_description[0].text;
    });
  }
};

const getDescription = (isExpandedView: boolean): string => {
  const { description } = props.pathway.data;
  if (description && isExpandedView) return description[0].text;
  return props.pathway.data.short_description ?? "";
};

const toggleExpandedView = (pathway: PathwayTileData, isOpen: boolean): void => {
  emit("toggle-expanded-view", { pathway, isOpen });
};

onMounted(() => {
  getBenefitList();
});

return (_ctx: any,_cache: any) => {
  return (_ctx.pathway.data.title_image)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([_ctx.isExpandedView ? 'expanded-tile' : 'pathway-tile'])
      }, [
        (!_ctx.isExpandedView)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "empty-close-icon",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleExpandedView(_ctx.pathway, true))),
              onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (toggleExpandedView(_ctx.pathway, true)), ["enter"]))
            }, null, 32))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h1", {
            innerHTML: _unref(cms).asHtml(_ctx.pathway.data.title),
            class: "pathway-title",
            "data-test": `pathway-title-${_ctx.pathway.pathwayUid}`
          }, null, 8, _hoisted_2),
          (_ctx.isExpandedView)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn-close-sm",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleExpandedView(_ctx.pathway, false))),
                "data-test": "close-expanded",
                type: "button"
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", {
              class: "pathway-desc",
              "data-test": `pathway-desc-${_ctx.pathway.pathwayUid}`
            }, _toDisplayString(getDescription(_ctx.isExpandedView)), 9, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("img", {
              src: _ctx.pathway.data.title_image.tile.url,
              alt: _unref(cms).asText(_ctx.pathway.data.title),
              class: "pathway-tile-img",
              "data-test": "pathway-tile-img"
            }, null, 8, _hoisted_7)
          ]),
          (_ctx.isExpandedView)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("ul", {
                  class: "benefits-list",
                  "data-test": `pathway-benefits-${_ctx.pathway.pathwayUid}`
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(benefits.value, (benefit, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: index,
                      class: "benefit-item"
                    }, [
                      _hoisted_11,
                      _createElementVNode("p", null, _toDisplayString(benefit), 1)
                    ]))
                  }), 128))
                ], 8, _hoisted_10)
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})